import {
  LOGOUT,
  USER_LOADED,
  USER_GROUP_SELECTED,
  GROUPS_LOADED,
} from "./ActionTypes";
import { Auth, Hub } from "aws-amplify";
import { getUserGroups } from "./Users";

/**
 * Closes active session
 */
export const logout = () => async (dispatch) => {
  await Auth.signOut();
  dispatch({ type: LOGOUT });

  // Reload the page after logout success
  window.location.reload();
};

export const userGroup = () => async (dispatch) => {
  try {
    const uGroups = await getUserGroups();
    dispatch({
      type: GROUPS_LOADED,
      payload: uGroups,
    });

    if (uGroups && uGroups.length === 1) {
      dispatch({
        type: USER_GROUP_SELECTED,
        payload: uGroups[0],
      });
    }
  } catch (err) {
    console.log("Get user group:", err);
  }
};

export const getAuthUserData = () => async (dispatch) => {
  try {
    const currentUser = await Auth.currentUserInfo();
    if (currentUser) {
      dispatch({
        type: USER_LOADED,
        payload: currentUser,
      });
      dispatch(userGroup());
    }

    Hub.listen("auth", async (data) => {
      if ("signIn" === data.payload.event) {
        const loginUser = await Auth.currentUserInfo();
        dispatch(userGroup());
        dispatch({
          type: USER_LOADED,
          payload: { ...data.payload.data.attributes, id: loginUser.id },
        });
      }
    });
  } catch (err) {
    console.log("error:", err);
  }
};
